module.exports = __webpack_public_path__ + "static/media/sunarch_32.4b31e51f.gif";